export default {
	namespaced: true,
	state() {
		return {
			secondaryOpen: false,
			activePrimary: '',
			activeSecondary: '',
			activeOption: '',
			secondaryHover: false,
      activeControls: [],
      secondaryHover: false,
      transferModeOn: false,
      disableBoard: false,
      siderailsCheck: false
		}
	},
	mutations: {
		setSecondaryOpen(state, value) {
			state.secondaryOpen = value
		},
    setSecondaryHover(state, value) {
			state.secondaryHover = value
		},
		setActivePrimary(state, value) {
			state.activePrimary = value
		},
		setActiveSecondary(state, value) {
			state.activeSecondary = value
		},
    setTransferModeOn(state, value) {
			state.transferModeOn = value
		},
    setDisableBoard(state, value) {
			state.disableBoard = value
		},
    setSiderailsCheck(state, value) {
			state.siderailsCheck = value
		},
		toggleActiveControl(state, control) {
			if (state.activeControls.includes(control)) {
        state.activeControls = state.activeControls.filter(i => i !== control)
      } else {
        state.activeControls.push(control)
      }
		}
	},
	actions: {
		setMainMenuItem({ commit, state }, item) {
			if ('submenu' in item) {
				// close previous submenu and reveal new one
				if (state.secondaryOpen && item.submenu !== state.activePrimary) {
					commit('setSecondaryOpen', false)
					commit('setExplanationPaneOpen', false , { root: true })
					setTimeout(() => {
						commit('setActiveSecondary', '')
						commit('setActivePrimary', item.submenu)
						commit('setSecondaryOpen', true)
					}, 450)
				} else {
					commit('setActivePrimary', item.submenu)
					commit('setSecondaryOpen', true)
				}
			} else {
				commit('setSecondaryOpen', false)
				commit('setActivePrimary', '')
				commit('setActiveSecondary', '')
				commit('setExplanationPaneOpen', false , { root: true })
			}
		}
	}
}